<template>
  <div class="details_con b-r">
    <div><slot name="h2"></slot></div>
    <div class="det_box"><slot name="con"></slot></div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {},
  components: {},
};
</script>

<style lang="less" scoped>
.details_con {
  width: 100%;
  padding: 0.25rem 0.45rem;
  background-color: #fff;
  margin-top: 0.23rem;

  h2 {
    margin: 0.18rem 0;
    font-size: 0.16rem;
  }
}
@media only screen and (max-width: 766px) {
  .details_con {
    h2 {
      font-size: 0.28rem;
    }
  }
}
</style>
